import { render } from "./AppHeader.vue?vue&type=template&id=09180b9a"
const script = {}

import exportComponent from "d:\\www\\.dev\\.vue\\n3t.bitbucket.io\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__